import { render, staticRenderFns } from "./cariSave.vue?vue&type=template&id=3b0569a6&"
import script from "./cariSave.vue?vue&type=script&lang=js&"
export * from "./cariSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports